/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import isApiError from "@insite/client-framework/Common/isApiError";
import { patch, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CreateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

const quotesUrl = "/api/v1/quotes";
const getTempQuoteUrl = "/api/custom/tempquote/";
const resetTempQuoteUrl = "/api/custom/tempquote/reset/";
const mergeCartToTempQuoteUrl = "/api/custom/tempquote/merge/";

export async function createQuote(createQuoteParameter: any): Promise<ServiceResult<QuoteModel>> {
    const customQuotesUrl =
        // eslint-disable-next-line no-prototype-builtins
        createQuoteParameter?.hasOwnProperty("poNumber") && createQuoteParameter["poNumber"] !== undefined
            ? `${quotesUrl}?poNumber=${createQuoteParameter["poNumber"]}`
            : quotesUrl;
    try {
        const quote = await post<CreateQuoteApiParameter, QuoteModel>(customQuotesUrl, createQuoteParameter);
        return {
            successful: true,
            result: quote,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export function getTempQuoteId(parameter: any) {
    return post<any>(`${getTempQuoteUrl}${parameter}`);
}

export function resetTempQuote(parameter: any) {
    return patch<any>(`${resetTempQuoteUrl}${parameter}`, parameter);
}

export function mergeCartToTempQuote(parameter: any) {
    return patch<any>(`${mergeCartToTempQuoteUrl}${parameter}`, parameter);
}